const customStyles = {
    rows: {
        style: {
            minHeight: '70px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the head cell padding
            paddingRight: '8px',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding
            paddingRight: '8px',
        },
    },
};

export default customStyles;
